let targetTrEl

function VxeGridTableEnhancementPlugin() {
  function VxeGridTableEnhancement() {
    this.defaults = {
      xTable: null,
      xTableTreeData: null,
      xEUtils: null,
      xTableTreeDataChildrenProp: 'children'
    }
  }

  VxeGridTableEnhancement.prototype = {
    dragStart({ dragEl }) {
      targetTrEl = dragEl
      document.addEventListener('dragleave', (evt) => {
        this._dragLeave(evt, dragEl)
      })
    },
    dragOverValid({ dragEl, target, onMove }) {
      if (target && target !== dragEl) {
        // If the row is expanded row
        if (target.classList.contains('vxe-body--expanded-row')) {
          targetTrEl = target.previousElementSibling
        } else if (onMove(target) !== false) {
          targetTrEl = target
        }

        targetTrEl.style.background = '#f0f0f0'
        targetTrEl.draggable = true
        targetTrEl.dataset.dropOnTo = true
      }
    },
    drop({ dragEl }) {
      const { xTableTreeData, xTableTreeDataChildrenProp, xTable, xEUtils } = this.options

      const rowIdKey = xTable.rowId || '_XID'

      if (xTableTreeData?.length > 0 && targetTrEl && targetTrEl !== dragEl) {
        let prevTrEl = dragEl.previousElementSibling
        let draggedNode = xEUtils.findTree(xTableTreeData, row => row[rowIdKey] === xTable.getRowNode(dragEl).item[rowIdKey], { children: xTableTreeDataChildrenProp })

        if (draggedNode) {
          let draggedRow = draggedNode.items.splice(draggedNode.index, 1)[0]

          if (prevTrEl) {
            let prevRow = xTable.getRowNode(prevTrEl).item
            let prevNode = xEUtils.findTree(xTableTreeData, row => row[rowIdKey] === prevRow[rowIdKey], { children: xTableTreeDataChildrenProp })

            if (targetTrEl.dataset.dropOnTo && targetTrEl.dataset.dropOnTo === 'true') {
              // Move dragged element to target node and set as child
              // this behaviors happens when the element is dropped over the target
              xTable.getRowNode(targetTrEl).item[xTableTreeDataChildrenProp].splice(0, 0, draggedRow)
            } else if (xTable.isTreeExpandByRow(prevRow)) {
              // Move dragged element to target node and set as child
              prevRow[xTableTreeDataChildrenProp].splice(0, 0, draggedRow)
            } else {
              prevNode.items.splice(prevNode.index + (draggedNode.index < prevNode.index ? 0 : 1), 0, draggedRow)
            }
          } else {
            xTableTreeData.unshift(draggedRow)
          }

          // While the tree level has changed, needs to refresh the tree data
          xTable.syncData()
        }
      }
    },
    nulling() {
      targetTrEl = null
    },
    _dragLeave(evt, dragEl) {
      // let targetTrEl = evt.target?.closest('tr')
      if (targetTrEl && dragEl !== targetTrEl) {
        targetTrEl.style.background = ''
        targetTrEl.dataset.dropOnTo = false
      }
    }
  }

  return Object.assign(VxeGridTableEnhancement, {
    pluginName: 'vxeGridTableEnhancement',
    eventProperties() {
      return {
        dropOnNodeItem: targetTrEl
      }
    }
  })
}

export default VxeGridTableEnhancementPlugin
